import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { useRequest } from "../System/RequestContext";
import { apiTenantSyncJobs, apiTenantSyncRelations } from "../../settings/ApiConfig";

const TenantSyncContext = createContext(null);

export function TenantSyncProvider({ children }) {
    const { GetRequest, PostRequest, DeleteRequest } = useRequest();
    const [relations, setRelations] = useState([]);
    const [job, setJob] = useState(null);

    const loadRelations = useCallback(async () => {
        const response = await GetRequest({ url: apiTenantSyncRelations });
        if (!response.hasError) setRelations(response.result || []);
        return response;
    }, [GetRequest]);

    const createRelation = useCallback(async (model) => {
        const response = await PostRequest({ url: apiTenantSyncRelations, body: model });
        if (!response.hasError) await loadRelations();
        return response;
    }, [PostRequest, loadRelations]);

    const revokeRelation = useCallback(async (relationId) => {
        const response = await DeleteRequest({ url: `${apiTenantSyncRelations}/${relationId}` });
        if (!response.hasError) await loadRelations();
        return response;
    }, [DeleteRequest, loadRelations]);

    const createJob = useCallback(async ({ syncType, relationIds, itemKeys }) => {
        const operationId = crypto.randomUUID();
        const response = await PostRequest({
            url: apiTenantSyncJobs,
            body: { operationId, syncType, relationIds, itemKeys }
        });
        if (!response.hasError) setJob(response.result);
        return response;
    }, [PostRequest]);

    const refreshJob = useCallback(async (jobId) => {
        const response = await GetRequest({ url: `${apiTenantSyncJobs}/${jobId}` });
        if (!response.hasError) setJob(response.result);
        return response;
    }, [GetRequest]);

    const value = useMemo(() => ({ relations, job, setJob, loadRelations, createRelation, revokeRelation, createJob, refreshJob }),
        [relations, job, loadRelations, createRelation, revokeRelation, createJob, refreshJob]);
    return <TenantSyncContext.Provider value={value}>{children}</TenantSyncContext.Provider>;
}

export function useTenantSync() {
    const context = useContext(TenantSyncContext);
    if (!context) throw new Error("useTenantSync debe utilizarse dentro de TenantSyncProvider");
    return context;
}
